<svg x="0px" y="0px" width="0px" height="0px" class="gf">
  <defs>
    <filter id="glow">
      <feDropShadow stdDeviation="20" flood-color="white" flood-opacity=".9" />
      <feDropShadow stdDeviation="40" flood-color="white" flood-opacity="1" />
    </filter>
  </defs>
</svg>

<style>
  .gf {
    position: absolute;
  }
</style>
